import React from "react";
import { Link } from "react-router-dom";

const Component404 = () => {
  return (
    <section className="section 404Section">
      <h1>404</h1>
      <h2>Page not found</h2>
      <Link to="/">Back to home page</Link>
    </section>
  );
};

export default Component404;
